{
  "connection": {
    "welcomeMessage": "Welcome, {{firstName}}!",
    "description": "Set up Chirpee in 15 minutes, and start collecting real-time employee insights.",
    "pill": {
      "setupNow": "Setup now",
      "connected": "Connected",
      "completed": "Completed"
    },
    "options": {
      "ssoConnected": {
        "title": "Connect your SSO",
        "description": "Set up single sign-on to manage access for your organization.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Manage"
      },
      "hrisConnected": {
        "title": "Connect your org chart",
        "description": "Import your organization structure to enable automated workflows.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      },
      "messagingConnected": {
        "title": "Connect communication tool",
        "description": "Collect employee’s feedback with your team’s communication platforms.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      },
      "billingSetup": {
        "title": "Setup billing",
        "description": "Add your billing information and choose a plan that fits your needs.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      },
      "branding": {
        "title": "Company branding",
        "description": "Customize your company’s branding to create a consistent workplace experience.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      }
    }
  },
  "billing": {
    "backToGettingStarted": "Back to getting started",
    "title": "Setup billing",
    "description": "Select the billing option that works best for your organization.",
    "currencyLabel": "Currency:",
    "currencyPlaceholder": "Currency",
    "taxDisclaimer": "All prices exclude applicable taxes.",
    "freeTrial": {
      "title": "Start with a 30-day free trial",
      "description": "No charge until your trial ends. Gather your first month of employee insights completely free."
    },
    "employeeCount": {
      "title": "Employee count",
      "hrisConnected": "HRIS connected",
      "pendingHrisSync": "Pending HRIS sync",
      "readonlyCount": "{{count}} employees",
      "description": "The number of employee seats is dynamic and based on the number of active users synced from your HRIS system who receive questions."
    },
    "plans": {
      "recommended": "Recommended",
      "perEmployeeMonth": "per employee / month",
      "employeeCountFormula": "{{count}} employees",
      "monthlyTotal": "Monthly total",
      "perMonth": "/ month",
      "launchingCheckout": "Launching checkout...",
      "monthly": {
        "title": "Monthly plan",
        "subtitle": "Billed monthly",
        "cta": "Select monthly plan"
      },
      "annual": {
        "title": "Annual plan",
        "subtitle": "Billed annually",
        "cta": "Select annual plan",
        "savingsBadge": "Save {{percent}}%",
        "savingsText": "Save {{amount}}/year with {{count}} employees"
      }
    },
    "features": {
      "title": "All features included in both plans",
      "comingSoon": "Coming soon",
      "items": {
        "dailyQuestionDelivery": "Daily question delivery",
        "enterpriseSecurity": "Enterprise-grade security",
        "slackTeamsIntegration": "Slack & Teams integration",
        "analyticsDashboard": "Complete analytics dashboard",
        "teamInsights": "Unlimited team insights",
        "hrisIntegration": "HRIS integration",
        "dedicatedSupport": "Dedicated support",
        "surveyBuilder": "Survey builder"
      }
    },
    "socialProof": {
      "title": "Why organizations choose continuous feedback",
      "cards": {
        "turnover": {
          "description": "Lower turnover rates in organizations with regular feedback",
          "source": "Gallup, 2023"
        },
        "managerEffectiveness": {
          "description": "Higher manager effectiveness with continuous employee insights",
          "source": "Harvard Business Review, 2022"
        },
        "profitMargins": {
          "description": "Higher profit margins in companies using continuous feedback systems",
          "source": "PwC, 2023"
        }
      }
    },
    "invoiceFooter": "Need invoice-based billing? Contact us at <supportLink>support@chirpee.co</supportLink>",
    "complete": {
      "title": "Payment Setup",
      "description": "Your payment setup is being confirmed. Return to Getting Started to continue onboarding."
    },
    "errors": {
      "chooseCurrency": "Choose a billing currency before continuing.",
      "stripeKeyMissing": "Stripe publishable key is not configured.",
      "checkoutStartFailed": "Unable to start checkout. Please try again.",
      "setupLoadFailed": "We could not load billing setup details.",
      "retry": "Retry",
      "pricingUnavailable": "Pricing is not available for {{currency}}. Please select another currency."
    }
  }
}
